import { render } from "./ViewVendorUserDetails.vue?vue&type=template&id=3f26ca57"
import script from "./ViewVendorUserDetails.vue?vue&type=script&lang=js"
export * from "./ViewVendorUserDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__